var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('yn-list',{attrs:{"name":"tasks","data":_vm.collection,"total":_vm.total,"skip":_vm.skip,"size":_vm.size,"sort":_vm.sort,"metadata":{
      question: {
        label: 'Question',
        width: '200px'
      },
      text: {
        label: 'Text',
        width: 'minmax(0, 1fr)'
      },
      label: {
        label: 'Label',
        width: '60px'
      },
      confidence: {
        label: 'Confidence',
        width: '85px'
      }
    },"sorting":[
      { id: null, label: 'Most labelled' },
      { id: 'complaint', label: 'Most reported' },
      { id: 'newest', label: 'Newest' },
      { id: 'oldest', label: 'Oldest' }
    ],"actions":[
      { name: 'view', label: '&#10149;', tooltip: 'View this task' },
      { name: 'delete', label: '&times;', tooltip: 'Delete this task' }
    ],"is-request-pending":_vm.isRequestPending,"is-request-failed":_vm.isRequestFailed},on:{"delete":_vm.remove,"view":_vm.view,"navigate":_vm.navigate,"sort":_vm.setSort},scopedSlots:_vm._u([{key:"gal",fn:function(ref){return undefined}},{key:"question",fn:function(ref){
    var value = ref.value;
    var item = ref.item;
return [_c('div',{staticClass:"task-question"},[(value)?_c('div',{},[_vm._v(_vm._s(value))]):_vm._e(),(Array.isArray(item.audit) && item.audit.find(function (item) { return !!item.complaint; }))?_c('i',{staticClass:"task-report"},[_vm._v("⚑")]):_vm._e()])]}},{key:"text",fn:function(ref){
    var value = ref.value;
return [(value)?_c('div',{staticClass:"task-text"},[_vm._v(_vm._s(_vm.$options.filters.truncate(value, 500)))]):_c('div',{staticClass:"task-text empty"},[_vm._v("Question is empty")])]}},{key:"confidence",fn:function(ref){
    var item = ref.item;
return [(Array.isArray(item.audit) && item.audit.length)?_c('span',{staticClass:"task-audit-confidence"},[_vm._v(" "+_vm._s((item.audit.filter(function (ref) {
        var label = ref.label;

        return label === item.label;
    }).length / item.audit.length).toFixed(2))+" ")]):_vm._e(),_c('span',{staticClass:"task-audit-count"},[_vm._v("("+_vm._s(item.audit.length)+")")])]}}])}),(!!_vm.selectedItem)?_c('yn-audit-modal',{attrs:{"item":_vm.selectedItem},on:{"close":function($event){_vm.selectedItem = null}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }